const initialState = {
  emailTemplates: [], // renamed from notifications
  unreadCount: 0,
  loading: false,
  error: null,
  scheduleEmailSuccess: false,
  userData: null,
};

export const emailTemplatesReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_EMAIL_TEMPLATES_REQUEST":
      return { ...state, loading: true, error: null };

    case "FETCH_EMAIL_TEMPLATES_SUCCESS":
      return {
        ...state,
        loading: false,
        emailTemplates: action.payload.templates || [],
        unreadCount: action.payload.total || 0,
      };

    case "FETCH_EMAIL_TEMPLATES_FAIL":
      return { ...state, loading: false, error: action.payload };

    case "MARK_EMAIL_TEMPLATES_READ_SUCCESS":
      return { ...state, unreadCount: 0 };

    case "MARK_EMAIL_TEMPLATES_READ_FAIL":
      return { ...state, error: "Failed to mark read" };

    case "UPDATE_UNREAD_EMAIL_COUNT":
      return { ...state, unreadCount: action.payload };
    case "GET_USER_REQUEST":
      return { ...state, loading: true, error: null };

    case "SCHEDULE_EMAIL_REQUEST":
      return { ...state, loading: true, error: null, scheduleEmailSuccess: false };

    case "SCHEDULE_EMAIL_SUCCESS":  
      return {
        ...state,
        loading: false,
        scheduleEmailSuccess: true,
        error: null
      };

    case "SCHEDULE_EMAIL_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
        scheduleEmailSuccess: false
      };

    case "GET_USER_SUCCESS":
      return {
        ...state,
        loading: false,
        userData: action.payload,
        error: null,
      };

    case "GET_USER_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
        userData: null,
      };

    default:
      return state;
  }
};
